
import { AxiosError, AxiosResponse, isAxiosError } from "axios";

/** Pull human-readable messages from DRF / mk_drfres error payloads. */
export function extractApiErrorMessages(...payloads: unknown[]): string[] {
    const messages: string[] = []
    const push = (value: unknown) => {
        if (value == null || value === "") return
        if (typeof value === "string") {
            messages.push(value)
            return
        }
        if (Array.isArray(value)) {
            value.forEach(push)
            return
        }
        if (typeof value === "object") {
            const record = value as Record<string, unknown>
            if (typeof record.error === "string") push(record.error)
            else if (typeof record.detail === "string") push(record.detail)
            else if (record.message) push(record.message)
            else if (Array.isArray(record.additionalDetails)) {
                record.additionalDetails.forEach((item) => {
                    if (item && typeof item === "object") {
                        const detail = item as Record<string, unknown>
                        if (typeof detail.message === "string") push(detail.message)
                        else if (typeof detail.detail === "string") push(detail.detail)
                    } else {
                        push(item)
                    }
                })
            }
            else if (Array.isArray(record.errors)) record.errors.forEach(push)
            else if (record.errors && typeof record.errors === "object") {
                Object.values(record.errors as Record<string, unknown>).forEach(push)
            }
        }
    }
    payloads.forEach(push)
    return [...new Set(messages.filter(Boolean))]
}

export function formatApiErrorMessage(...payloads: unknown[]): string {
    const messages = extractApiErrorMessages(...payloads)
    return messages.length ? messages.join(" ") : "Unknown error"
}

export function processResponse<T>(axsiosResponse: AxiosResponse<T>) {
    let status: number, data: T, x: any
    ({ status, data, ...x } = axsiosResponse || {});

    if (status >= 200 && status < 400) {
        return { data, error: null, originalError: null }
    } else {
        let errorResponse = ((axsiosResponse as unknown) as AxiosError)?.response?.data || {} as any
        let originalError = ((axsiosResponse as unknown) as AxiosError)?.response?.data || {} as any

        let error = formatApiErrorMessage(errorResponse, originalError)

        if (x.code == 'ERR_NETWORK') {
            originalError = { detail: navigator.onLine ? 'Connection to server interrupted or unavailable' : 'Network error' }
            error = formatApiErrorMessage(errorResponse, originalError)
        }
        return { data: null, error, originalError, status }
    }
}

export function processResultsResponse<T extends Array<any>, META = any, DATA = any>(axsiosResponse: AxiosResponse<ApiResultsResponse<T, META>>) {
    let list: T | null
    let { data, error, originalError } = processResponse(axsiosResponse)
    list = !error && Array.isArray(data?.results) && data!.results || (data?[data]:null) as any
    return { list, meta: data?.meta, error, originalError, originalResponse: data as DATA, next: data?.next || null, previous: data?.previous || null, count: data?.count || null }
}


export enum RequestStatus {
    BLANK = 0,
    WAITING = 1,
    SUCCESS = 2,
    ERROR = 3
}

